// Formats Turkish phone numbers: 05XXXXXXXXX or 5XXXXXXXXX → 0 (5XX) XXX XX XX
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return "—";
  const digits = phone.replace(/\D/g, "");
  const normalized = digits.startsWith("90") ? digits.slice(2) : digits.startsWith("0") ? digits.slice(1) : digits;
  if (normalized.length !== 10) return phone;
  return `(${normalized.slice(0, 3)}) ${normalized.slice(3, 6)} ${normalized.slice(6, 8)} ${normalized.slice(8)}`;
}

// Strips separators and leading +90 / 90 / 0 prefixes → at most 10 digits.
// Mirrors the mobile app's lib/phone.ts and the backend PhoneNormalizer contract.
export function normalizePhone(raw: string | null | undefined): string {
  let d = (raw ?? "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("90")) d = d.slice(2);
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 10);
}

// Progressive masked display while typing: (532) 123 45 67
export function formatPhoneInput(raw: string | null | undefined): string {
  const d = normalizePhone(raw);
  if (!d) return "";
  let out = `(${d.slice(0, 3)}`;
  if (d.length < 3) return out; // "(5", "(53"
  out += ")"; // "(532)"
  const rest = [d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean);
  return rest.length ? `${out} ${rest.join(" ")}` : out;
}

// True when the normalized value is exactly 10 digits.
export function isValidPhone(raw: string | null | undefined): boolean {
  return /^[0-9]{10}$/.test(normalizePhone(raw));
}
